// Google Tag Manager evnt types as defined by Webiteers
export enum GTMEventTypes {
  ADD_PAYMENT_INFO = 'add_payment_info', // onClick paymentMethod
  ADD_SHIPPING_INFO = 'add_shipping_info', // not implemented yet
  ADD_TO_CART = 'add_to_cart', // within `onAddToCart`
  BEGIN_CHECKOUT = 'begin_checkout', // onLoad APP_ROUTES.CHECKOUT
  ENHANCED_CONVERSION = 'enhanced_conversion', // Manual trigger
  PURCHASE = 'purchase', // onLoad APP_ROUTES.CHECKOUT_SUCCESS
  REMOVE_FROM_CART = 'remove_from_cart', // within `onDeleteCartItem` in APP_ROUTES.SHOPPINGCART
  SELECT_ITEM = 'select_item', // onClick productTile, condition: items was in `view_item_list`
  VIEW_CART = 'view_cart', // onLoad APP_ROUTES.SHOPPINGCART
  VIEW_ITEM = 'view_item', // onLoad product details page
  VIEW_ITEM_LIST = 'view_item_list' // onMount ProductTileList
}

export interface GtmPurchaseEvent {
  event?: GTMEventTypes;
  ecommerce?: {
    transaction_id?: string;
    value?: number; // Sum of all items
    tax?: number;
    shipping?: number;
    currency?: string;
    coupon?: string;
    items?: IPurchaseEventItem[];
  };
}

export interface IPurchaseEventItem {
  affiliation?: string;
  coupon?: string;
  discount?: number;
  index?: number;
  item_brand?: string;
  item_category2?: string;
  item_category3?: string;
  item_category4?: string;
  item_category5?: string;
  item_category?: string;
  item_id?: string;
  item_list_id?: string;
  item_list_name?: string;
  item_name?: string;
  item_variant?: string;
  location_id?: string;
  price?: number;
  promotion_id?: string;
  promotion_name?: string;
  quantity?: number;
}

export interface GtmViewCartEvent {
  event?: GTMEventTypes;
  ecommerce?: {
    currency?: string;
    value?: number;
    items?: IViewCartEventItem[];
  };
}

export interface IViewCartEventItem {
  item_id?: string;
  item_name?: string;
  item_brand?: string;
  item_category?: string;
  item_category2?: string;
  item_category3?: string;
  price?: number;
  quantity?: number;
}

export interface GtmEnhancedConversionEvent {
  event?: GTMEventTypes.ENHANCED_CONVERSION;
  email?: string;
}

export interface GtmAddToCartEvent {
  event?: GTMEventTypes.ADD_TO_CART;
  ecommerce?: {
    currency?: string;
    value?: number;
    items?: IViewCartEventItem[];
  };
}

export interface GtmRemoveFromCartEvent {
  event?: GTMEventTypes.REMOVE_FROM_CART;
  ecommerce?: {
    currency?: string;
    value?: number;
    items?: IViewCartEventItem[];
  };
}

export interface GtmAddShippingInfoEvent {
  event?: GTMEventTypes.ADD_SHIPPING_INFO;
  ecommerce?: {
    currency?: string;
    shipping_tier?: string;
    value?: number;
    items?: IViewCartEventItem[];
  };
}

export interface GtmAddPaymentInfoEvent {
  event?: GTMEventTypes.ADD_PAYMENT_INFO;
  ecommerce?: {
    currency?: string;
    payment_type?: string;
    value?: number;
    items?: IViewCartEventItem[];
  };
}

export interface GtmViewItemEvent {
  event?: GTMEventTypes.VIEW_ITEM;
  ecommerce?: {
    currency?: string;
    value?: number;
    items?: IViewCartEventItem[];
  };
}

export interface GtmViewItemListEvent {
  event?: GTMEventTypes.VIEW_ITEM_LIST;
  ecommerce?: {
    item_list_id?: string;
    item_list_name?: string;
    items?: IViewCartEventItem[];
  };
}
